import cn from 'classnames';
import { TypeAnimation } from 'react-type-animation';
import { Transition } from '@headlessui/react';

const MessageOne = ({ isShowing, setStep }) => (
  <Transition
    show={isShowing}
    enter="transition-all transform ease duration-500"
    enterFrom="opacity-0 -translate-x-full"
    enterTo="opacity-100 translate-x-0"
    leave="transition-all transform ease duration-150"
    leaveFrom="opacity-100"
    leaveTo="opacity-0"
  >
    <div className="flex space-x-2">
      <img
        className="inline-block w-6 h-6 rounded-full ring-2 ring-neutral-600"
        src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"
        alt=""
      />

      <TypeAnimation
        sequence={[
          'Why is human feedback necessary for accurate llm responses?',
          1000,
          () => setStep(4)
        ]}
        speed={60}
        wrapper="div"
        cursor={false}
        className={cn('px-2.5 py-1 rounded-xl bg-neutral-700 w-fit transition-opacity')}
      />
    </div>
  </Transition>
);

export default MessageOne;
